export default __webpack_public_path__ + "static/media/sticky.fae6c553.svg";